<!--
 * @Author: natsu
 * @Date: 2020-04-17 16:34:45
 * @LastEditors: natsu
 * @LastEditTime: 2020-04-17 16:42:00
 * @Description: file content
 -->
<template>
  <div class="wrapper">
    <header class="bg">

      <h2>jquery.qrcode</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>jquery.qrcode</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/jquery.qrcode/'
export default {
  name: 'index',
  data() {
    return {
      fileList: [
        {
          label: '1.0',
          linkList: [
            ur + '1.0/jquery.qrcode.min.js'
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListJqueryQrcode.vue